module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_HR-32638c7ba54f4190ec62a2a5b1959712.svg";